<div style="width:100%;text-align:center;position:relative;">
		<div class="overfondo" style="position:absolute;right:3px;top:5px" (click)="cancelar()"><mat-icon style="font-size:25pt">cancel</mat-icon></div>
		<div *ngIf="cantidadimagenes >= 1 && numimagen >= 1" style="position:absolute; left:3px; top:200px;" (click)="anteriorimg()"><mat-icon style="font-size:25pt">arrow_back</mat-icon>
		</div>
		<div *ngIf="cantidadimagenes >= 1 && numimagen < cantidadimagenes -1" style="position:absolute; right:3px; top:200px;" (click)="siguienteimg()"><mat-icon style="font-size:25pt">arrow_forward</mat-icon>
		</div>
<img style="width:40%" [src]="imagenactual"/>
</div>